import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.css';

export interface IPaginationWrapperProps extends React.PropsWithChildren {
  disabled?: boolean;

  onPrev?(): void;

  onNext?(): void;
}

export const PaginationWrapper: React.FC<IPaginationWrapperProps> = ({ children, disabled }) => (
  <div className={clsx(styles['wrapper'], { [styles['disabled']]: disabled })}>
    <div className={styles['items']}>{children}</div>
  </div>
);

PaginationWrapper.displayName = 'PaginationWrapper';
